import { styled } from "@mui/material/styles";
import { TextField } from "@mui/material";

export const StyledTextField = styled(TextField)(({ theme }) => ({
    backgroundColor: "#fff",
    borderRadius: "8px",
    // padding: "15px",
    width: "95%",
    marginLeft: "5px",
    paddingLeft: "10px",
    "& .MuiInputBase-root": {
        fontSize: "1rem",
        padding: "10px 12px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
        borderColor: theme.palette.black,
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "#A0C500",
    },
    "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "#A0C500",
    },
}));
